module.exports = __webpack_public_path__ + "img/resources-b.52044de8.png";